import { ProductLinePermission } from 'src/app/core/interfaces/permissions';
import { SettingsWebhooksManagementPage } from './pages';
import { Settings } from './developer-settings.setup';

export const DeveloperSettingsModule: ProductLinePermission = {
  id: Settings.id,
  title: 'PAGE.DEVELOPER_SETTINGS.TITLE',
  path: Settings.path,
  pages: [
    SettingsWebhooksManagementPage,
  ],
  showInSidebar: false,
};
